import { render, staticRenderFns } from "./DeleteEventActions.vue?vue&type=template&id=e6ce2532&"
import script from "./DeleteEventActions.vue?vue&type=script&lang=js&"
export * from "./DeleteEventActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports